import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'rcp-skeleton-table',
  template: `
    <div class="rcp-skeleton-container">
      <div class="rcp-skeleton-row">
        @for (c of colItems(); track 'c-' + i; let i = $index) {
          <div class="rcp-skeleton-table-column">
            <div class="rcp-skeleton-table-header"></div>
          </div>
        }
      </div>
      @for (r of rowItems(); track 'r-' + i; let i = $index) {
        <div class="rcp-skeleton-table-row shimmer"></div>
      }
    </div>
  `,
  styleUrls: ['./skeleton.components.scss'],
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SkeletonTableComponent {
  // number of items to show
  rows = input(3);
  columns = input(1);

  rowItems = computed(() => Array.from({ length: this.rows() }));
  colItems = computed(() => Array.from({ length: this.columns() }));
}
